module.exports = __webpack_public_path__ + "img/icon-document@350h.cd6eba93.png";